export const DEFAULT_FETCHING_STATE = {state: false, config: {}};

export const DEFAULT_NO_ERROR = { timestamp: 0, message: '' };